import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import TableColumnDate from 'components/reusable/TableColumnDate';
import useIsUiHidden from 'hooks/dom/useIsUiHidden';

import ExpandableButton from '../../ExpandableButton';
import ProfTable from '../../ProfTable';
import { ReactComponent as ExternalLink } from 'assets/img/icons/external-link.svg';

const PressReleasesTable = ({ pressReleases }) => {
  const { t } = useTranslation();
  const isUiHidden = useIsUiHidden();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const handleExpand = (record, e) => {
    e.stopPropagation();
    setExpandedRowKeys(prev => (prev.includes(record.id) ? prev.filter(id => id !== record.id) : [...prev, record.id]));
  };

  const pressReleasesColumns = [
    {
      title: t('global.dataSource'),
      dataIndex: 'sourceLogo',
      key: 'sourceLogo',
      render: (sourceLogo, record) =>
        sourceLogo && record.uri ? (
          <a href={record.uri} target="_blank" rel="noopener noreferrer" className="align-items-center">
            <img src={sourceLogo} alt="Trademark Thumbnail" style={{ padding: 0, maxHeight: 26 }} />
            <ExternalLink style={{ marginLeft: 5 }} />
          </a>
        ) : sourceLogo && !record.uri ? (
          <img src={sourceLogo} alt="Trademark Thumbnail" style={{ padding: 0, maxHeight: 26 }} />
        ) : record.uri ? (
          <a href={record.uri} target="_blank" rel="noopener noreferrer" className="align-items-center">
            <ExternalLink style={{ marginLeft: 5 }} />
          </a>
        ) : (
          '-'
        ),
    },
    {
      title: t('professionalReport.basicData.press.pressReleases.table.title'),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: t('professionalReport.basicData.press.pressReleases.date'),
      dataIndex: 'publishDate',
      render: TableColumnDate,
      key: 'publishDate',
      width: 200,
      sorter: (a, b) => new Date(b.publishDate) - new Date(a.publishDate),
      sortDirections: ['ascend', 'descend'],
      defaultSortOrder: 'ascend',
    },
    ...(!isUiHidden
      ? [
          {
            width: 120,
            key: 'description',
            render: (_, record) => {
              return record?.description ? (
                <ExpandableButton
                  withText
                  isActive={expandedRowKeys.includes(record.id)}
                  onClick={e => handleExpand(record, e)}
                />
              ) : null;
            },
          },
        ]
      : []),
  ];

  return (
    <ProfTable
      showSorterTooltip={false}
      bordered
      rowKey="id"
      dataSource={pressReleases}
      columns={pressReleasesColumns}
      pagination={isUiHidden ? false : { defaultPageSize: 10, showSizeChanger: true }}
      expandable={{
        expandedRowRender: record => (
          <div>
            <p>{record.description}</p>
            <p>
              {t('professionalReport.basicData.rekvizitaiContactInformation.uri')}:
              <a
                href={record.uri}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: 5, textDecoration: 'underline' }}
              >
                {record.uri}
              </a>
            </p>
          </div>
        ),
        rowExpandable: record => record.description,
        defaultExpandAllRows: isUiHidden,
        expandIconColumnIndex: -1,
        expandedRowKeys,
        onExpandedRowsChange: setExpandedRowKeys,
      }}
    />
  );
};

export default PressReleasesTable;
